/**
 * Live Data Configuration
 *
 * Reads the live data worker URL from the Vite define'd env var set on the
 * CF Pages project. Sites without the env var skip live fetching and use
 * baked data.
 */

declare global {
  interface ImportMetaEnv {
    LIVE_DATA_WORKER_URL?: string;
  }
}

export function getLiveDataUrl(): string | null {
  const url = import.meta.env.LIVE_DATA_WORKER_URL;
  return url ? url.replace(/\/+$/, '') : null;
}
